import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

export const useAccountColumns = (
  page,
  PAGE_SIZE,
  handleEdit,
  handleDelete
) => {
  const [t] = useTranslation();

  return useMemo(
    () => [
      {
        Header: "#",
        id: "index",
        Cell: (props) => {
          return (
            <span className="text-center">
              {props.row.index + 1 + (page - 1) * PAGE_SIZE}
            </span>
          );
        },
      },
      {
        Header: t("auth.username"),
        accessor: "username",
      },
      {
        Header: t("signup.name"),
        accessor: "first_name",
      },
      {
        Header: t("signup.last_name"),
        accessor: "last_name",
      },
      {
        Header: t("student.email"),
        accessor: "email",
      },
      {
        Header: t("signup.phone_number"),
        accessor: "phone_number",
      },
      {
        Header: t("team.role"),
        accessor: "roles",
        Cell: ({ value }) => {
          return value.map((role) => role.name).join(", ");
        },
      },
      {
        Header: t("team.his_team"),
        accessor: "teams",
        Cell: ({ value }) => {
          return (
            <div className="flex flex-col">
              {value.map((team) => (
                <div
                  key={team.uuid}
                  className="flex flex-col text-sm text-gray-500 gap-0.5"
                >
                  <p>{team.name}</p>
                  <p
                    className={
                      team.status === "DRAFT"
                        ? "text-gray-500"
                        : team.status === "APPROVED"
                        ? "text-green-500"
                        : "text-red-500"
                    }
                  >
                    {team.status}
                  </p>
                </div>
              ))}
            </div>
          );
        },
      },

      {
        Header: t("admin.actions"),
        accessor: "uuid",
        Cell: ({ row }) => (
          <div className="flex gap-2">
            <Button
              Icon={PencilSquareIcon}
              onClick={() => handleEdit(row.original)}
              color="primary"
            />
            <Button
              Icon={TrashIcon}
              onClick={() => handleDelete(row.original)}
              color="error"
            />
          </div>
        ),
      },
    ],
    [t, page, PAGE_SIZE, handleEdit, handleDelete]
  );
};
